var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vs-container" }, [
    _c(
      "div",
      { staticClass: "payouts__form-required" },
      [
        !_vm.currentUser.valid_w9
          ? [
              _c("h1", [
                _vm._v(
                  "W-9 or W-8 required before " +
                    _vm._s(_vm.payoutText) +
                    " are available."
                )
              ]),
              _vm._m(0),
              _c("br"),
              _vm._m(1),
              _c("h5", [
                _vm._v(
                  "Once the W-9 or W-8 is received and verified, return to this screen to process " +
                    _vm._s(_vm.payoutText) +
                    "."
                )
              ])
            ]
          : _vm.currentUser._links.send_email_verification.href
          ? [
              _c("h1", [
                _vm._v(
                  "Email must be verified before " +
                    _vm._s(_vm.payoutText) +
                    " are available."
                )
              ]),
              !_vm.emailVerificationRequested
                ? _c("vs-button", {
                    attrs: {
                      large: "large",
                      text: "Resend Verification Email",
                      processing: _vm.processing,
                      disabled: _vm.processing
                    },
                    on: { click: _vm.handleResendVerificationEmailClick }
                  })
                : [
                    _c("h3", [_vm._v("Verification Email Sent!")]),
                    _c("h5", [
                      _vm._v(
                        "Once your email is verified, return to this screen or refresh the page if you have not left."
                      )
                    ])
                  ]
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c(
        "a",
        {
          staticClass: "vs-link",
          attrs: {
            href: "https://app.hellosign.com/s/d6cee5c2",
            target: "_blank"
          }
        },
        [_vm._v("Click here ")]
      ),
      _vm._v("to submit W-9 form.")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("Outside of the US? "),
      _c(
        "a",
        {
          staticClass: "vs-link",
          attrs: {
            href: "https://app.hellosign.com/s/4efd5b27",
            target: "_blank"
          }
        },
        [_vm._v("Click here ")]
      ),
      _vm._v("to submit W-8 form.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }